import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { getDashboardData, getProfileData } from "../../../apis/auth";
import { createNewFinancerPayment } from "../../../apis/financers";
import RenderRazorpay from "../../../razorpay";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { getAllAdvertisement } from "../../../apis/advertizement";

const AdminDashboard = () => {
  const [profile, setProfile] = useState<any | undefined>([]);
  const [company, setCompany] = useState<any | undefined>([]);
  const [transactAmount, setTransactAmount] = useState<number | undefined>();
  const [aadharAmount, setAadharAmount] = useState<number | undefined>();
  const [smsTokenAmount, setSmsTokenAmount] = useState<string | undefined>();
  const [openRazorPay, setOpenRazorPay] = useState<boolean | false>();
  const [aadharTokenAmount, setAadharTokenAmount] = useState<
    string | undefined
  >();
  const [type, setType] = useState<any>();
  const userInfo = JSON.parse(sessionStorage.getItem("info"));
  const allowedRoutes = JSON.parse(
    JSON.parse(sessionStorage.getItem("routes"))
  );
  const employeeRoutes = allowedRoutes?.map(
    (item: { route: any }) => item.route
  );

  const submitButton = () => { };

  const smsCharges = 0.3;
  const aadharCharges = 4;
  const fetchProfileData = async () => {
    try {
      const response = await getProfileData();
      setCompany(response?.companyName);
      setProfile(response?.data);
    } catch (error) {
      console.error(error, "error");
    }
  };

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value } = e.target;
    setSmsTokenAmount(value);
  };

  useEffect(() => {
    if (smsTokenAmount) {
      const amount = parseFloat(smsTokenAmount);
      if (!isNaN(amount)) {
        const calculatedAmount = amount * smsCharges;
        setTransactAmount(Math.round(calculatedAmount * 100) / 100);
      } else {
        setTransactAmount(undefined);
      }
    }
    if (aadharTokenAmount) {
      const amount = parseFloat(aadharTokenAmount);
      if (!isNaN(amount)) {
        const calculatedAmount = amount * aadharCharges;
        setAadharAmount(Math.round(calculatedAmount * 100) / 100);
      } else {
        setAadharAmount(undefined);
      }
    }
  }, [smsTokenAmount, aadharTokenAmount]);
  const handlepayment = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const payload = {
        financer_id: profile.id,
        transaction_amount: Number(transactAmount),
        sms_token_limit: Number(smsTokenAmount),
      };
      // const response = await createNewFinancerPayment(payload);
      await createNewFinancerPayment(payload);
      setOpenRazorPay(true);
    } catch (error) {
      console.error(error, "error");
    }
    setTransactAmount(undefined);
  };
  const handleAadhar = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    try {
      const payload = {
        financer_id: profile.id,
        transaction_amount: Number(aadharAmount),
        aadhar_token_limit: Number(aadharTokenAmount),
      };
      // const response = await createNewFinancerPayment(payload);
      await createNewFinancerPayment(payload);
      setOpenRazorPay(true);
    } catch (error) {
      console.error(error, "error");
    }
    setTransactAmount(undefined);
  };

  const [dashData, setDashData] = useState<any>();

  const fetchAlldashboardData = async () => {
    const data = {
      start_date: "",
      end_date: "",
    };
    try {
      const response = await getDashboardData(data);
      if (response.status === true) {
        const newResponse = response.data;
        setDashData(newResponse);
      }
    } catch (error) {
      console.error(error, "error");
    }
  };

  const [advertizeData, setAdvertisement] = useState<any[]>([]);
  const settings = {
    infinite: advertizeData?.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };
  const fetchAllImages = async () => {
    try {
      const data = {
        start_date: "",
        end_date: "",
      };
      const response = await getAllAdvertisement(data);
      if (response.status === true) {
        const newResponse = response.data;
        setAdvertisement(newResponse);
      }
    } catch (error) {
      console.error(error, "getAllAdvertisement error");
    }
  };

  useEffect(() => {
    fetchAllImages();
    fetchProfileData();
    if (userInfo.type !== "retailer" && userInfo.type !== "employee") {
      fetchAlldashboardData();
    }
    setType(userInfo.type);
  }, []);

  if (userInfo?.type === "retailer" || userInfo.type === "employee") {
    return (
      <>
        <div className="page-wrapper">
          <div className="row box-plr-0 pt-10 my-10">
            <div
              className="col-12"
              style={{
                background:
                  "linear-gradient(135deg, rgb(58 181 75 / 29%), rgb(84 218 212))", // green gradient
                borderRadius: "12px",
                padding: "7px",
                color: "#fff", // white text for contrast
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                textAlign: "center",
                width: "95%",
                margin: "2.5% auto 0",
              }}
            >
              <h2 style={{ marginBottom: "10px", fontWeight: "600" }}>
                {company?.company_name || profile?.company_name}
              </h2>
              <h4 style={{ margin: 0, fontWeight: "500" }}>
                Welcome, {profile?.full_name}
              </h4>
            </div>
          </div>

          <div className="content padding-7rem">
            <div className="row box-plr-0">
              <div className="col-6 ">
                <Link
                  to="/emi_calculator"
                  className="card shadow-sm transition-all"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    borderRadius: "16px",
                    textDecoration: "none",
                    background: "linear-gradient(135deg, #e1f5fe, #b3e5fc)", // Soft blue gradient
                    color: "#333",
                    minWidth: "160px",
                  }}
                >
                  <div className="card-body card-body-dashboard">
                    <span
                      className="avatar rounded-circle mb-2"
                      style={{
                        backgroundColor: "#ffffff",
                        color: "#3ab54b",
                        padding: "15px",
                        fontSize: "20px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      }}
                    >
                      <i className="fas fa-hand-holding-usd"></i>{" "}
                    </span>
                    <span style={{ fontWeight: "600", fontSize: "16px" }}>
                      Emi Calculator
                    </span>
                  </div>
                </Link>
              </div>
              {(employeeRoutes?.includes("/apply-form") ||
                userInfo?.type === "retailer") && (
                  <div className="col-6 ">
                    <Link
                      to="/apply-form"
                      className="card shadow-sm transition-all"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "16px",
                        textDecoration: "none",
                        background: "linear-gradient(135deg, #e1f5fe, #b3e5fc)", // Soft blue gradient
                        color: "#333",
                        minWidth: "160px",
                      }}
                    >
                      <div className="card-body card-body-dashboard">
                        <span
                          className="avatar rounded-circle mb-2"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#3ab54b",
                            padding: "15px",
                            fontSize: "20px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          }}
                        >
                          <i className="fas fa-hand-holding-usd"></i>{" "}
                        </span>
                        <span style={{ fontWeight: "600", fontSize: "16px" }}>
                          Apply Loan
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
              {(employeeRoutes?.includes("/customers") ||
                userInfo?.type === "retailer") && (
                  <div className="col-6">
                    <Link
                      to="/customers"
                      className="card shadow-sm transition-all"
                      style={{
                        // marginRight: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "16px",
                        textDecoration: "none",
                        background: "linear-gradient(135deg, #e8f7f6, #d0f0f0)", // Soft teal gradient
                        color: "#333",
                        minWidth: "160px",
                      }}
                    >
                      <div className="card-body card-body-dashboard">
                        <span
                          className="avatar rounded-circle mb-2"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#3ab54b",
                            padding: "15px",
                            fontSize: "20px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          }}
                        >
                          <i className="fas fa-users"></i>{" "}
                          {/* Icon updated to represent customers */}
                        </span>
                        <span style={{ fontWeight: "600", fontSize: "16px" }}>
                          Customer List
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
              {(employeeRoutes?.includes("/staffs") ||
                userInfo?.type === "retailer") && (
                  <div className="col-6">
                    <Link
                      to="/staffs"
                      className="card shadow-sm transition-all"
                      style={{
                        // marginRight: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "16px",
                        textDecoration: "none",
                        background: "linear-gradient(135deg, #f3e5f5, #d1c4e9)", // Soft purple gradient
                        color: "#333",
                        minWidth: "160px",
                      }}
                    >
                      <div className="card-body card-body-dashboard">
                        <span
                          className="avatar rounded-circle mb-2"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#3ab54b",
                            padding: "15px",
                            fontSize: "20px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          }}
                        >
                          <i className="fas fa-users-cog"></i>{" "}
                          {/* Icon updated to represent staff */}
                        </span>
                        <span style={{ fontWeight: "600", fontSize: "16px" }}>
                          Staff List
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
              {(employeeRoutes?.includes("/emis-records") ||
                userInfo?.type === "retailer") && (
                  <div className="col-6">
                    <Link
                      to="/emis-records"
                      className="card shadow-sm transition-all"
                      style={{
                        // marginRight: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "16px",
                        textDecoration: "none",
                        background: "linear-gradient(135deg, #ffecb3, #ffb74d)", // Soft yellow-orange gradient
                        color: "#333",
                        minWidth: "160px",
                      }}
                    >
                      <div className="card-body card-body-dashboard">
                        <span
                          className="avatar rounded-circle mb-2"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#3ab54b",
                            padding: "15px",
                            fontSize: "20px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          }}
                        >
                          <i className="fas fa-money-bill-wave"></i>{" "}
                          {/* Icon updated to represent payments or bills */}
                        </span>
                        <span style={{ fontWeight: "600", fontSize: "16px" }}>
                          Pending EMIs
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
              {(employeeRoutes?.includes("/disbursement_loan") ||
                userInfo?.type === "retailer") && (
                  <div className="col-6">
                    <Link
                      to="/disbursement_loan"
                      className="card shadow-sm transition-all"
                      style={{
                        // marginRight: "10px",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "16px",
                        textDecoration: "none",
                        background: "linear-gradient(135deg, #81c784, #388e3c)", // Green gradient for a financial feel
                        color: "#fff",
                        minWidth: "160px",
                      }}
                    >
                      <div className="card-body card-body-dashboard">
                        <span
                          className="avatar rounded-circle mb-2"
                          style={{
                            backgroundColor: "#ffffff",
                            color: "#388e3c",
                            padding: "15px",
                            fontSize: "20px",
                            boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                          }}
                        >
                          <i className="ti ti-wallet fs-16" />{" "}
                          {/* Updated icon for a financial/loan feel */}
                        </span>
                        <span style={{ fontWeight: "600", fontSize: "16px" }}>
                          Disbursement Loan
                        </span>
                      </div>
                    </Link>
                  </div>
                )}
              {employeeRoutes?.includes("/verification") && (
                <div className="col-6">
                  <Link
                    to="/verification"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #64b5f6, #1976d2)", // Blue gradient for trust and verification
                      color: "#fff",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#1976d2",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-check-circle fs-16" />{" "}
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Verification
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/pending-visit") && (
                <div className="col-6">
                  <Link
                    to="/pending-visit"
                    className="card shadow-sm hover-shadow transition-all box-layout-css"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #a8e6cf, #b3e5fc)",
                      color: "#333",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-users"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Pending Visit
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/regular-visitors") && (
                <div className="col-6">
                  <Link
                    to="/regular-visitors"
                    className="card shadow-sm hover-shadow transition-all box-layout-css"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #a8e6cf, #b3e5fc)",
                      color: "#333",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        {/* <i className="fas fa-users"></i> */}
                        <i
                          className="fas fa-calendar-check"
                          aria-hidden="true"
                        ></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Regular Visit
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/visited-list") && (
                <div className="col-6">
                  <Link
                    to="/visited-list"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #c8e6c9, #b3e5fc)",
                      color: "#333",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-clipboard-check"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Visited List
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/finance-visitors") && (
                <div className="col-6">
                  <Link
                    to="/finance-visitors"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #d1f4ff, #b2dfdb)", // Soft finance-related tones
                      color: "#333",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-hand-holding-usd"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Finance Visitors
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/finance-retailers") && (
                <div className="col-6">
                  <Link
                    to="/finance-retailers"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #e0f7fa, #c8e6c9)", // Light finance theme
                      color: "#333",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-store-alt"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Finance Retailer
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/visitors") && (
                <div className="col-6">
                  <Link
                    to="/visitors"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #dcedc8, #b2ebf2)", // Fresh and light for "Visitors"
                      color: "#333",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-user-friends"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Visitors
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/dist-visitors") && (
                <div className="col-6">
                  <Link
                    to="/dist-visitors"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #e0f2f1, #dcedc8)", // Light distributor theme
                      color: "#333",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-truck-loading"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Distributor Visitors
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/finance-visitors") && (
                <div className="col-6">
                  <Link
                    to="/finance-visitors"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #e8f5e9, #c8e6c9)", // Light green finance theme
                      color: "#333",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-user-tie"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Finance Visitors
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/finance-retailers") && (
                <div className="col-6">
                  <Link
                    to="/finance-retailers"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #f1f8e9, #dcedc8)", // Soft green theme
                      color: "#333",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-store-alt"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Finance Retailer
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/cibil") && (
                <div className="col-6">
                  <Link
                    to="/cibil"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #e8f5fc, #d0e8f2)", // Light blue gradient for financial data
                      color: "#333",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-id-card-alt"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Cibil
                      </span>
                    </div>
                  </Link>
                </div>
              )}
              {employeeRoutes?.includes("/super-distributor") && (
                <div className="col-6">
                  <Link
                    to="/super-distributor"
                    className="card shadow-sm transition-all"
                    style={{
                      // marginRight: "10px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      borderRadius: "16px",
                      textDecoration: "none",
                      background: "linear-gradient(135deg, #e8fce8, #d0f0d0)", // Soft green gradient
                      color: "#333",
                      minWidth: "160px",
                    }}
                  >
                    <div className="card-body card-body-dashboard">
                      <span
                        className="avatar rounded-circle mb-2"
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#3ab54b",
                          padding: "15px",
                          fontSize: "20px",
                          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                        }}
                      >
                        <i className="fas fa-user-tie"></i>
                      </span>
                      <span style={{ fontWeight: "600", fontSize: "16px" }}>
                        Super Distributor
                      </span>
                    </div>
                  </Link>
                </div>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <div style={{ margin: "15px 0px" }}>
            <Slider {...settings}>
              {advertizeData &&
                advertizeData.map((item: any, i: number) => (
                  <div key={i}>
                    <div
                      style={{
                        height: "200px",
                        borderRadius: "5px",
                        overflow: "hidden",
                      }}
                    >
                      <img
                        src={item.image}
                        alt={`Slide ${i + 1}`}
                        style={{
                          borderRadius: "5px",
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />
                    </div>
                  </div>
                ))}
            </Slider>
          </div>
          <div className="row">
            <div className="col-xxl-8 d-flex">
              <div className="row flex-fill">
                {type === "financer" && (
                  <div className="head-icons ms-2">
                    <div
                      className="me-3"
                      style={{
                        display: "flex",
                        gap: "10px",
                        width: "100%",
                        justifyContent: "end",
                      }}
                    >
                      <div>
                        <button
                          data-bs-toggle="modal"
                          data-inert={true}
                          data-bs-target="#sms_wallet"
                          className="btn btn-primary"
                        >
                          Sms Wallet
                        </button>
                      </div>
                      <div>
                        <button
                          data-bs-toggle="modal"
                          data-inert={true}
                          data-bs-target="#aadhar_wallet"
                          className="btn btn-primary"
                        >
                          Aadhar Wallet
                        </button>
                      </div>
                    </div>
                  </div>
                )}

                <div className="modal fade" id="sms_wallet">
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="d-flex align-items-center">
                          <h4 className="modal-title me-2">Sms Wallet</h4>
                        </div>
                        <button
                          type="button"
                          className="btn-close custom-btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          <i className="ti ti-x" />
                        </button>
                      </div>

                      <form onSubmit={handlepayment}>
                        <div className="contact-grids-tab">
                          <ul
                            className="nav nav-underline"
                            id="myTab"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link active"
                                id="info-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#basic-info"
                                type="button"
                                role="tab"
                                aria-selected="true"
                              >
                                Basic Information
                              </button>
                            </li>
                            <li className="nav-item" role="presentation"></li>
                          </ul>
                        </div>
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="basic-info"
                            role="tabpanel"
                            aria-labelledby="info-tab"
                            tabIndex={0}
                          >
                            <div className="modal-body pb-0 ">
                              <div className="row">
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Sms Token Wallet
                                      <span className="text-danger"> *</span>
                                    </label>
                                    <input
                                      type="number"
                                      value={smsTokenAmount || ""} // Provide a default value for controlled input
                                      onChange={handleChange}
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Transaction Amount
                                      <span className="text-danger"> *</span>
                                    </label>
                                    <input
                                      type="number"
                                      value={transactAmount || ""} // Provide a default value for controlled input
                                      className="form-control"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-outline-light border me-2"
                                data-bs-dismiss="modal"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                data-bs-dismiss="modal"
                                className="btn btn-primary"
                              >
                                Submit{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                <div className="modal fade" id="aadhar_wallet">
                  <div className="modal-dialog modal-dialog-centered modal-lg">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div className="d-flex align-items-center">
                          <h4 className="modal-title me-2">Aadhar Wallet</h4>
                        </div>
                        <button
                          type="button"
                          className="btn-close custom-btn-close"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                        >
                          <i className="ti ti-x" />
                        </button>
                      </div>

                      <form onSubmit={handleAadhar}>
                        <div className="contact-grids-tab">
                          <ul
                            className="nav nav-underline"
                            id="myTab"
                            role="tablist"
                          >
                            <li className="nav-item" role="presentation">
                              <button
                                className="nav-link active"
                                id="info-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#basic-info"
                                type="button"
                                role="tab"
                                aria-selected="true"
                              >
                                Basic Information
                              </button>
                            </li>
                            <li className="nav-item" role="presentation"></li>
                          </ul>
                        </div>
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="basic-info"
                            role="tabpanel"
                            aria-labelledby="info-tab"
                            tabIndex={0}
                          >
                            <div className="modal-body pb-0 ">
                              <div className="row">
                                <div className="col-md-12"></div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Aadhar Token Wallet
                                      <span className="text-danger"> *</span>
                                    </label>
                                    <input
                                      type="number"
                                      value={aadharTokenAmount || ""} // Provide a default value for controlled input
                                      onChange={(e) =>
                                        setAadharTokenAmount(e.target.value)
                                      }
                                      className="form-control"
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6">
                                  <div className="mb-3">
                                    <label className="form-label">
                                      Transaction Amount
                                      <span className="text-danger"> *</span>
                                    </label>
                                    <input
                                      type="number"
                                      value={aadharAmount || ""} // Provide a default value for controlled input
                                      className="form-control"
                                      disabled
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div className="modal-footer">
                              <button
                                type="button"
                                className="btn btn-outline-light border me-2"
                                data-bs-dismiss="modal"
                              >
                                Cancel
                              </button>
                              <button
                                type="submit"
                                data-bs-dismiss="modal"
                                className="btn btn-primary"
                              >
                                Submit{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>

                {type === "master" && (
                  <div className="col-md-3 d-flex">
                    <div className="card flex-fill">
                      <div className="card-body">
                        <span className="avatar rounded-circle bg-primary mb-2">
                          <i className="ti ti-users-group fs-16" />
                        </span>
                        <h6 className="fs-13 fw-medium text-default mb-1">
                          Total Nationals
                        </h6>
                        <h3 className="mb-3">
                          {dashData?.nationalCount || "0"}
                          {/* <span className="fs-12 fw-medium text-success">
                          <i className="fa-solid fa-caret-up me-1" />
                          +2.1%
                        </span> */}
                        </h3>
                        <Link to="/nationals" className="link-default">
                          View Details
                        </Link>
                      </div>
                    </div>
                  </div>
                )}

                {(type === "master" || type === "national") && (
                  <div className="col-md-3 d-flex">
                    <div className="card flex-fill">
                      <div className="card-body">
                        <span className="avatar rounded-circle bg-secondary mb-2">
                          <i className="ti ti-users-group fs-16" />
                        </span>
                        <h6 className="fs-13 fw-medium text-default mb-1">
                          Total Super-Distributors
                        </h6>
                        <h3 className="mb-3">
                          {dashData?.superDistributorCount || "0"}
                          {/* <span className="fs-12 fw-medium text-danger">
                          <i className="fa-solid fa-caret-down me-1" />
                          -2.1%
                        </span> */}
                        </h3>
                        <Link to="/super-distributor" className="link-default">
                          View All
                        </Link>
                      </div>
                    </div>
                  </div>
                )}
                {(type === "master" ||
                  type === "national" ||
                  type === "super_distributer") && (
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-info mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Total Distributors
                          </h6>
                          <h3 className="mb-3">
                            {dashData?.distributerCount || "0"}
                            {/* <span className="fs-12 fw-medium text-danger">
                          <i className="fa-solid fa-caret-down me-1" />
                          -11.2%
                        </span> */}
                          </h3>
                          <Link to="/distributor" className="link-default">
                            View All
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                {(type === "master" ||
                  type === "national" ||
                  type === "super_distributer" ||
                  type === "distributer") && (
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-pink mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Total Financers
                          </h6>

                          <h3 className="mb-3">
                            {dashData?.financerCount || "0"}
                            {/* <span className="fs-12 fw-medium text-success">
                          <i className="fa-solid fa-caret-down me-1" />
                          +11.2%
                        </span> */}
                          </h3>
                          <Link to="/financers" className="link-default">
                            View All
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                {(type === "master" ||
                  type === "national" ||
                  type === "super_distributer" ||
                  type === "distributer" ||
                  type === "financer") && (
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-purple mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Total Retailer
                          </h6>
                          <h3 className="mb-3">
                            {dashData?.retailerCount || "0"}
                            {/* <span className="fs-12 fw-medium text-success">
                          <i className="fa-solid fa-caret-up me-1" />
                          +10.2%
                        </span> */}
                          </h3>
                          <Link to="/retailerslist" className="link-default">
                            View All
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                {(type === "master" ||
                  type === "national" ||
                  type === "super_distributer" ||
                  type === "distributer" ||
                  type === "financer" ||
                  type === "retailer") && (
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-danger mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Total Employees
                          </h6>
                          <h3 className="mb-3">
                            {dashData?.employeeData || "0"}
                            {/* <span className="fs-12 fw-medium text-success">
                          <i className="fa-solid fa-caret-up me-1" />
                          +2.1%
                        </span> */}
                          </h3>
                          <Link to="/staffs" className="link-default">
                            View All
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}

                {(type === "master" ||
                  type === "national" ||
                  type === "financer" ||
                  type === "retailer") && (
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-success mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Total Customers
                          </h6>
                          <h3 className="mb-3">
                            {dashData?.customerCount || "0"}
                            {/* <span className="fs-12 fw-medium text-success">
                          <i className="fa-solid fa-caret-up me-1" />
                          +2.1%
                        </span> */}
                          </h3>
                          <Link to="/customers" className="link-default">
                            View All
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}

                {(type === "master" ||
                  type === "national" ||
                  type === "super_distributer" ||
                  type === "distributer") && (
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-dark mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Visitors
                          </h6>
                          <h3 className="mb-3">
                            {dashData?.visitorsCount || "0"}

                            {/* <span className="fs-12 fw-medium text-danger">
                          <i className="fa-solid fa-caret-down me-1" />
                          -11.2%
                        </span> */}
                          </h3>
                          <Link to="/pending-visit" className="link-default">
                            Pending Visit
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                {(type === "master" ||
                  type === "national" ||
                  type === "super_distributer" ||
                  type === "distributer") && (
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-dark mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Visitors
                          </h6>
                          <h3 className="mb-3">
                            {dashData?.visitorsCount || "0"}

                            {/* <span className="fs-12 fw-medium text-danger">
                          <i className="fa-solid fa-caret-down me-1" />
                          -11.2%
                        </span> */}
                          </h3>
                          <Link to="/regular-visitors" className="link-default">
                            Regular Visit
                          </Link>
                        </div>
                      </div>
                    </div>
                  )}
                {(type === "master" || type === "financer") && (
                  <>
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-purple mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Total Aadhar Token
                          </h6>
                          <h3 className="mb-3">
                            {dashData?.totalAadharTokenLimit || "0"}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-dark mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Total Aadhar Token
                          </h6>
                          <h3 className="mb-3">
                            {dashData?.totalSmsTokenLimit || "0"}
                          </h3>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-3 d-flex">
                      <div className="card flex-fill">
                        <div className="card-body">
                          <span className="avatar rounded-circle bg-purple mb-2">
                            <i className="ti ti-users-group fs-16" />
                          </span>
                          <h6 className="fs-13 fw-medium text-default mb-1">
                            Total Amount
                          </h6>
                          <h3 className="mb-3">
                            {dashData?.totalAmount || "0"}
                          </h3>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      {openRazorPay && (
        <RenderRazorpay orderId={1} submitButton={submitButton} amount={200} />
      )}
    </>
  );
};

export default AdminDashboard;
